import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './assets/icon/iconfont.css'
import './plugins/element.js'
import './assets/styles/min.less'
import './assets/styles/assets.css'
import './assets/styles/default.less'
import './adaptation/adaptation.js'

Vue.config.productionTip = false
Vue.use(ElementUI)
axios.defaults.baseURL = 'http://localhost/clothing/public/api/v1'

Vue.prototype.$http = axios

axios.interceptors.request.use(config => {
  config.headers.Authorization = window.sessionStorage.getItem('token')
  return config
})
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
